import React from 'react';
import { View } from 'react-native';

import Entry from 'app/src/styles/mobileTable';
import { Link } from 'app/src/utils/routing';

const MobileRow = ({ entry, columns }) => {
  const actionColumn = columns[columns.length - 1];

  return (
    <Entry.Container>
      {columns[1].content({ entry, value: entry.name })}
      {columns[2].content({ entry, value: entry.lastOrderName })}
      <Entry.Text>
        {entry.licenses.map(license => license.licenseString).join(', ')}
      </Entry.Text>
      {actionColumn.content({ entry })}
    </Entry.Container>
  );
};

export default MobileRow;
